import { createMetaRoute } from '@funtech-int/rival';

import { RouteMeta } from '@/shared/lib/navigation';

export const selectionRoute = createMetaRoute<RouteMeta, { id: string }>({
    key: (params) => params.id,
});
